import { useContext } from "react";
import { AppContext } from "../../Context/AppContext";
import "./LayoutDemo.scss";

function LayoutDemo(props) {
	const { theme } = useContext(AppContext);
	return (
		<div className='layout-demo-wrapper'>
			<div>Пример отображения шрифтов:</div>
			<div
				className='layout-demo'
				style={{
					fontSize: `${(16 / theme.scaleFactor) * theme.fontMultiplier}px`,
				}}
			>
				<div
					className='demo-header'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.headerFontMultiplier
						}px`,
					}}
				>
					Заголовок
				</div>
				<div
					className='demo-body-left'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.bodyLeftFontMultiplier
						}px`,
					}}
				>
					Левая колонка
				</div>
				<div
					className='demo-body-center'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.bodyCenterFontMultiplier
						}px`,
					}}
				>
					Центральная колонка
				</div>
				<div
					className='demo-body-right'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.bodyRightFontMultiplier
						}px`,
					}}
				>
					Правая колонка
				</div>
				<div
					className='demo-footer'
					style={{
						fontSize: `${
							(16 / theme.scaleFactor) * theme.footerFontMultiplier
						}px`,
					}}
				>
					Подвал
				</div>
			</div>
		</div>
	);
}

export default LayoutDemo;
